import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useBackButton } from '@/lib/tg-buttons';

interface Props {
  title: string;
  subtitle?: string;
  back?: boolean;
  right?: React.ReactNode;
}

export const PageHeader = ({ title, subtitle, back = true, right }: Props) => {
  const nav = useNavigate();
  useBackButton(() => nav(-1), back);

  return (
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="flex items-start gap-2">
        {back && (
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={() => nav(-1)}
            className="-ml-1.5 mt-0.5"
          >
            <ArrowLeft className="h-4.5 w-4.5" />
          </Button>
        )}
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {subtitle && (
            <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
      {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
    </div>
  );
};
